import React, { useEffect, useState } from 'react';
const NAMES = ['María', 'Lucía', 'Valentina', 'Camila', 'Sofía', 'Isabella', 'Mariana', 'Gabriela', 'Andrea', 'Carolina', 'Daniela', 'Fernanda', 'Alejandra', 'Paula', 'Natalia', 'Laura', 'Ana', 'Catalina', 'Jimena', 'Florencia', 'Romina', 'Agustina', 'Julieta', 'Milagros', 'Celeste', 'Rocío', 'Guadalupe', 'Antonella', 'Bianca', 'Renata'];
const CITIES = ['Buenos Aires, Argentina', 'Córdoba, Argentina', 'Rosario, Argentina', 'Mendoza, Argentina', 'Bogotá, Colombia', 'Medellín, Colombia', 'Ciudad de México, México', 'Guadalajara, México', 'Monterrey, México', 'Lima, Perú', 'Santiago, Chile', 'Quito, Ecuador', 'Guayaquil, Ecuador', 'Montevideo, Uruguay', 'Asunción, Paraguay', 'La Paz, Bolivia', 'San José, Costa Rica', 'Panamá, Panamá', 'Santo Domingo, Rep. Dominicana', 'Caracas, Venezuela', 'Tucumán, Argentina', 'Mar del Plata, Argentina', 'Salta, Argentina', 'Santa Fe, Argentina', 'Cali, Colombia', 'Barranquilla, Colombia', 'Puebla, México', 'Cancún, México', 'Arequipa, Perú', 'Valparaíso, Chile'];
function getRandom(arr: string[]) {
  return arr[Math.floor(Math.random() * arr.length)];
}
function getTimeAgo() {
  const minutes = Math.floor(Math.random() * 10) + 1;
  return `hace ${minutes} min`;
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [name, setName] = useState('');
  const [city, setCity] = useState('');
  const [timeAgo, setTimeAgo] = useState('');
  useEffect(() => {
    const showPopup = () => {
      setName(getRandom(NAMES));
      setCity(getRandom(CITIES));
      setTimeAgo(getTimeAgo());
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
      }, 4000);
    };
    // First popup after 8 seconds
    const initialTimeout = setTimeout(showPopup, 8000);
    // Then every 20 seconds
    const interval = setInterval(showPopup, 20000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <div className={`fixed bottom-5 left-5 z-50 transition-all duration-500 ${visible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0 pointer-events-none'}`} data-id="element-276">
      <div className="bg-white rounded-xl shadow-[0_8px_32px_rgba(30,45,36,0.18)] border border-forest/10 py-3.5 px-5 flex items-center gap-3.5 max-w-[340px]" data-id="element-277">
        <div className="w-10 h-10 rounded-full bg-forest/10 flex items-center justify-center shrink-0" data-id="element-278">
          <span className="text-lg" data-id="element-279">✅</span>
        </div>
        <div className="flex-1 min-w-0" data-id="element-280">
          <p className="text-[0.82rem] text-text-dark font-medium leading-snug" data-id="element-281">
            <span className="font-semibold" data-id="element-282">{name}</span> de {city}
          </p>
          <p className="text-[0.72rem] text-forest font-medium mt-0.5" data-id="element-283">
            accedió recién al programa
          </p>
          <p className="text-[0.65rem] text-text-light mt-0.5" data-id="element-284">{'ahora'}</p>
        </div>
        <button onClick={() => setVisible(false)} className="text-text-light hover:text-text-dark text-lg leading-none shrink-0 bg-transparent border-none cursor-pointer p-1" aria-label="Cerrar notificación" data-id="element-285">
          ×
        </button>
      </div>
    </div>;
}